import React, { useState } from 'react';
import { PlusIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-white" data-id="element-39" data-mp="1iy1cnu1gsp54">
      <div className="max-w-3xl mx-auto" data-id="element-40" data-mp="1nvt46my7698s">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text text-center mb-12" data-id="element-41" data-mp="1nwvvgvzfmdp8">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-42" data-mp="2fmh4xxvylclx">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="bg-brand-panel rounded-2xl overflow-hidden border border-brand-creamDark/60" data-id="element-43" data-mp="21u185etniatg" data-mpi={i}>
                <h3 data-id="element-44" data-mp="2uiyecjkl8h5u">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-green" data-id="element-45" data-mp="2uigb32zid2of">
                    <span className="font-bold text-brand-text" data-id="element-46" data-mp="20ougujuqsyvf">{faq.q}</span>
                    <span className="shrink-0 text-brand-text" data-id="element-47" data-mp="20mrgb5vyrncg">
                      {isOpen ? <XIcon className="w-5 h-5" aria-hidden="true" data-id="element-48" data-mp="2ffuz1glak74r" /> : <PlusIcon className="w-5 h-5" aria-hidden="true" data-id="element-49" data-mp="2agrststkruv7" />}
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-50" data-mp="2jgn9ue9tak35">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-51" data-mp="u1gt0t4enhm4">
                      <p className="px-6 pb-5 text-brand-gray leading-relaxed" data-id="element-52" data-mp="2z0oussnj7f03">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}